export default "__VITE_ASSET__V3Yk_K$7__"